<template>
  <Popover
    ref="popover"
    :location="location"
    :maxWidth="maxWidth"
  >
    <template #trigger="{ props }">
      <slot name="trigger">
        <AppTooltip>
          <template #activator="{ props: tooltipProps }">
            <app-button
              v-bind="{ ...props, ...tooltipProps }"
              size="small"
              type="icon"
            >
              <app-icon-ds icon="trash-can" size="xs" class="text-grey-darken-1" />
            </app-button>
          </template>
          <span>{{ $t('common.delete') }}</span>
        </AppTooltip>
      </slot>
    </template>

    {{ effectiveConfirmationText }}

    <template #actions>
      <app-button
        size="small"
        type="outlined"
        variant="neutral"
        @click="close"
      >
        {{ $t('common.cancel') }}
      </app-button>
      <app-button
        size="small"
        variant="danger"
        @click="confirmDelete"
      >
        {{ $t('common.confirmDelete') }}
      </app-button>
    </template>
  </Popover>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

import Popover from './Popover.vue'

export default {
  name: 'DeletePopover',
  components: { AppTooltip, Popover },
  emits: ['confirm'],
  props: {
    item: {
      type: Object,
      required: true,
    },
    location: {
      type: String,
      default: 'top',
    },
    confirmationText: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: [String, Number],
      default: 'auto',
    },
  },
  computed: {
    effectiveConfirmationText () {
      return this.confirmationText || this.$t('common.deleteConfirmationText')
    },
  },
  methods: {
    confirmDelete () {
      this.$emit('confirm', this.item)
      this.close()
    },
    close () {
      this.$refs.popover?.close()
    },
  },
}
</script>
